export const TRUSTPILOT_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';
